<template>
    <p class="p-1">
        <Icon family="fa" name="fa-user" helperClass="has-text-primary" />
        <span class="pl-2">{{ user.name }}</span
        ><span v-if="showIdentification"> ({{ user.identification }})</span>
    </p>
</template>

<script>
export default {
    name: "conected-user",
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    computed: {
        showIdentification() {
            return (
                this.haveIdentification &&
                this.user.name !== this.user.identification
            );
        },
        haveIdentification() {
            return (
                this.user.identification !== "" &&
                this.user.identification !== undefined &&
                this.user.identification !== null
            );
        },
    },
};
</script>